import Pages from '@pages/names';

export default [
  Pages.Home,
  Pages.Snapshot,
  Pages.Ranking,
  Pages.MyProfile,
  Pages.RankingDetails
];
